import { useContext } from "react";
import { OrderHistoryTableContext } from "../context/OrderHistoryTableContext";

export const useOrderHistoryTable = () => {
    const ctx = useContext(OrderHistoryTableContext);
    
    if (!ctx) {
        throw new Error("useOrderHistoryPagination must be used within OrderHistoryPaginationProvider");
    }

    return ctx;
};
